import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
  SearchFilterFacet,
  WorkingTime,
} from '@savgroup-front-common/types';
import { SearchResultList } from '@savgroup-front-common/types/SearchResultList';

const ENDPOINT = `${APIConfiguration.search}filteredtechnicians`;

export interface SearchTechnicianResult {
  userId: string;
  firstName?: string;
  lastName?: string;
  fullName?: string;
  email?: string;
  phone?: string;
  specialization?: string[];
  seniority?: string;
  assignedStocks?: string[];
  optimizationIncluded: boolean;
  maxComplexityPerDay: number;
  workingTimes?: WorkingTime[];
}

export interface FilterTechniciansCommandArgs {
  query?: string;
  page?: number;
  pageSize?: number;
  sort?: string;
  isDescending?: boolean;
  filters?: SearchFilterFacet[];
  sellerId?: string;
}

export const filterTechniciansCommand = async ({
  query,
  page,
  pageSize,
  sort,
  isDescending,
  filters,
  sellerId,
}: FilterTechniciansCommandArgs): Promise<
  BackResponse<SearchResultList<SearchTechnicianResult>> | BackResponseFailure
> => {
  try {
    return await apiCall<
      BackResponse<SearchResultList<SearchTechnicianResult>>
    >(ENDPOINT, {
      method: SUPPORTED_METHODS.POST,
      json: {
        query,
        page,
        pageSize,
        sort,
        isDescending,
        filters,
        sellerId,
      },
    });
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
